import React, { useState } from 'react';
import axios from 'axios'; // Para realizar requisições HTTP
import 'bootstrap/dist/css/bootstrap.min.css';

function Fale() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    isClient: '',
    subject: '',
    message: '',
  });

  const [isSubmitted, setIsSubmitted] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage(''); // Limpa mensagens de erro anteriores

    try {
      // Faz a requisição para a API
      const response = await axios.post('https://api.lf.dev.br/contact', formData, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (response.data.success) {
        setIsSubmitted(true);
      }
    } catch (error) {
      console.error('Erro ao enviar o formulário:', error);
      setErrorMessage(
        error.response?.data?.error || 'Ocorreu um erro ao enviar sua mensagem. Tente novamente mais tarde.'
      );
    }
  };

  return (
    <div className="container" style={{ marginTop: '120px' }}>
      <div className="row justify-content-center">
        <div className="col-md-8">
          <h1 className="text-center mb-4">Fale Conosco</h1>
          <p className="text-center">
            Preencha o formulário abaixo para entrar em contato conosco.
          </p>
          {!isSubmitted ? (
            <form onSubmit={handleSubmit} className="p-4 border rounded shadow-sm bg-white">
              <div className="mb-3">
                <label htmlFor="name" className="form-label">
                  Nome
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="Seu nome completo"
                  required
                />
              </div>
              <div className="mb-3">
                <label htmlFor="email" className="form-label">
                  E-mail
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="Seu e-mail"
                  required
                />
              </div>
              <div className="mb-3">
                <label htmlFor="phone" className="form-label">
                  Telefone
                </label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="(DDD) 12345-6789"
                />
              </div>
              <div className="mb-3">
                <label htmlFor="isClient" className="form-label">
                  Você já é nosso cliente?
                </label>
                <select
                  id="isClient"
                  name="isClient"
                  value={formData.isClient}
                  onChange={handleChange}
                  className="form-select"
                  required
                >
                  <option value="" disabled>Selecione uma opção</option>
                  <option value="Sim">Sim</option>
                  <option value="Não">Não</option>
                </select>
              </div>
              <div className="mb-3">
                <label htmlFor="subject" className="form-label">
                  Assunto
                </label>
                <select
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  className="form-select"
                  required
                >
                  <option value="" disabled>Selecione um assunto</option>
                  <option value="Solicitação de orçamentos">Solicitação de orçamentos</option>
                  <option value="Solicitação de suporte">Solicitação de suporte</option>
                  <option value="Dúvidas">Dúvidas</option>
                  <option value="Elogios ou sugestões">Elogios ou sugestões</option>
                </select>
              </div>
              <div className="mb-3">
                <label htmlFor="message" className="form-label">
                  Mensagem
                </label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  className="form-control"
                  rows="5"
                  placeholder="Escreva sua mensagem"
                  required
                />
              </div>
              {errorMessage && (
                <div className="alert alert-danger" role="alert">
                  {errorMessage}
                </div>
              )}
              <button type="submit" className="btn btn-primary w-100">
                Enviar
              </button>
            </form>
          ) : (
            <div className="thank-you-message text-center mt-5">
              <h2 className="text-success">Obrigado pelo contato!</h2>
              <p>Recebemos sua mensagem e entraremos em contato em breve.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Fale;
